import { appColors } from '../../styles/theme';

export const getStyles = (theme) => ({
    navbar: {
        left: '72px',
        right: 0,
        zIndex: 999,
        height: '56px',
        backgroundColor: appColors.page.background,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 24px',
        [theme.breakpoints.down('md')]: {
            left: '56px',
            padding: '0 16px',
        },
        [theme.breakpoints.down('sm')]: {
            left: 0,
            padding: '0 12px',
        },
    },
    navLeftContent: {
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        flex: 1,
        minWidth: 0,
        gap: '4px',
    },
    navRightContent: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        marginLeft: theme.spacing(2),
    },
    navbarBrand: {
        height: '28px',
        width: '120px',
        marginRight: '16px',
        display: 'flex',
        alignItems: 'center',
        objectFit: 'contain',
        [theme.breakpoints.down('sm')]: {
            width: '90px',
            marginRight: '8px',
        },
    },
})
